/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { XdaStringsService } from '../../services/xda-strings.service';
import { XdaTranslate } from '../../pipes/xda-translate.pipe';
import { BrowserService } from '../../services/browser.service';

@Component({
  selector: 'country-code-modal',
  templateUrl: './country-code-modal.component.html',
  styleUrls: ['./country-code-modal.component.less'],
  standalone: false,
})
export class CountryCodeModalComponent implements OnInit {
  @Input() countries: any;
  @Input() countryCode: string;
  @Input() savedSelectedCountry: any;
  @Input() isMfd: boolean;

  searchTerm = '';
  direction = 'asc';
  column = '';
  type = 'string';
  searchMinLength = 3;
  searchPlaceholder = '';
  clearTooltip: string;
  showClearSearch = false;
  searchIsValid = true;
  selected: any;
  scrollClass = '';

  private xdaTranslatePipe: XdaTranslate;
  constructor(
    private xdaStringsService: XdaStringsService,
    public activeModal: NgbActiveModal,
    private browserService: BrowserService,
  ) {
    this.xdaTranslatePipe = new XdaTranslate(this.xdaStringsService);
    this.scrollClass =
      this.browserService.browserType() < 3 ? '' : 'nativeScroll';
    this.clearTooltip = this.xdaStringsService.strings['SDE_CLEAR_SEARCH'];
  }

  ngOnInit(): void {
    // set selected sate
    this.countries.forEach((c: any) => {
      // if a user re-opens the country code modal after selecting a country select the country they chose before
      if (
        this.savedSelectedCountry &&
        this.savedSelectedCountry.value == this.countryCode &&
        c.value == this.countryCode &&
        c.key == this.savedSelectedCountry.key
      ) {
        c.selected = true;
      } else {
        c.selected = false;
      }

      // insert translated strings for key to be used to sort the table correctly in different locals
      c.keyTranslated = this.xdaTranslatePipe.transform(c.key);
    });

    // translate search placeholder
    this.searchPlaceholder = this.xdaTranslatePipe.transform(
      'SDE_ENTER_FMTSTR_MORE',
      [String(this.searchMinLength)],
    );

    if (this.isMfd) {
      this.setSortParams({
        direction: this.direction,
        column: 'keyTranslated',
        type: this.type,
      });
    }
  }

  setSortParams(param: any) {
    this.direction = param.direction;
    this.column = param.column;
    this.type = param.type;
  }

  validateSearch(event: any) {
    // both keyup and blur call this function so figure out which event triggered the validation check
    if (event.type == 'keyup') {
      // for keyup we only want to validate the searchTerm length is less then the min length but greater than 0 if the enter key is hit
      if (
        event.keyCode == '13' &&
        this.searchTerm.length < this.searchMinLength &&
        this.searchTerm.length > 0
      ) {
        this.searchIsValid = false;
      } else {
        this.searchIsValid = true;
      }
    } else {
      // on blur check if the searchTerm length is less then the min length but greater than 0
      if (
        this.searchTerm.length < this.searchMinLength &&
        this.searchTerm.length > 0
      ) {
        this.searchIsValid = false;
      } else {
        this.searchIsValid = true;
      }
    }

    // show the clear search button if the searchTerm is greater then or equal to 1
    this.showClearSearch = this.searchTerm.length >= 1 ? true : false;
  }

  clearSearch() {
    this.searchTerm = '';
    this.searchIsValid = true;
    this.showClearSearch = false;
  }

  rowClicked(country: any) {
    // reset selected row
    this.countries.forEach((c: any) => {
      if (c.selected) {
        c.selected = false;
      }
    });
    // set selected row
    country.selected = true;
    this.selected = country;
  }
}
